const carousel = document.querySelector(".reviews-content__content");
const nextBtn = document.querySelector(".right");
const prevBtn = document.querySelector(".left");
const indicators = document.querySelectorAll(".nav-indicator");
let currentIndex = 0;
let prevIndex;
const reviews = Array.from(document.querySelectorAll(".review"));
const totalReviews = Object.keys(reviews).length;
const reviewWidth = reviews[1].offsetWidth;

// Touch handling variables
let touchStartX = 0;
let touchEndX = 0;
let isDragging = false;
const minSwipeDistance = 100;

// Update indicators function
function updateIndicators(newIndex) {
  indicators.forEach((indicator, index) => {
    if (index === newIndex) {
      indicator.classList.add("active");
    } else {
      indicator.classList.remove("active");
    }
  });
}

function slideNext() {
  carousel.classList.add("sliding-animation");

  prevIndex = currentIndex;
  currentIndex = (currentIndex + 1) % totalReviews;

  carousel.style.transform = `translateX(-${reviewWidth}px)`;
  updateIndicators(currentIndex);
  setTimeout(() => {
    carousel.appendChild(reviews[prevIndex]);
    carousel.classList.remove("sliding-animation");
    carousel.style.transform = "";
  }, 500);
}

function slidePrev() {
  prevIndex = currentIndex;
  currentIndex = (currentIndex - 1 + totalReviews) % totalReviews;

  // Move Carousel to the left
  carousel.style.transform = `translateX(-${reviewWidth}px)`;
  carousel.insertBefore(reviews[currentIndex], carousel.firstChild);
  updateIndicators(currentIndex);
  // start the transition effect, from -px to 0 px.
  setTimeout(() => {
    carousel.style.transform = "";
    carousel.classList.add("sliding-animation");
  }, 10);

  setTimeout(() => {
    carousel.classList.remove("sliding-animation");
  }, 490);
}

function handleTouchStart(event) {
  touchStartX = event.touches[0].clientX;
  isDragging = true;
  // Disable the sliding animation during drag
  carousel.classList.remove("sliding-animation");
}

function handleTouchMove(event) {
  if (!isDragging) return;

  touchEndX = event.touches[0].clientX;
  const diffX = touchStartX - touchEndX;
  // Add real-time dragging feedback
  carousel.style.transform = `translateX(${-diffX}px)`;
}

function handleTouchEnd() {
  if (!isDragging) return;

  const swipeDistance = touchStartX - touchEndX;

  // Reset dragging state
  isDragging = false;
  carousel.style.transform = "";

  // If swipe distance is greater than minimum, trigger slide
  if (Math.abs(swipeDistance) > minSwipeDistance) {
    if (swipeDistance > 0) {
      slideNext();
    } else {
      slidePrev();
    }
  } else {
    // If swipe wasn't long enough, reset position
    carousel.classList.add("sliding-animation");
    carousel.style.transform = "";
    setTimeout(() => {
      carousel.classList.remove("sliding-animation");
    }, 300);
  }

  // Reset touch coordinates
  touchStartX = 0;
  touchEndX = 0;
}
updateIndicators(currentIndex);
// Add existing click event listeners
if (nextBtn || prevBtn){
  nextBtn.addEventListener("click", slideNext);
  prevBtn.addEventListener("click", slidePrev);
  carousel.addEventListener("touchstart", handleTouchStart);
  carousel.addEventListener("touchmove", handleTouchMove);
  carousel.addEventListener("touchend", handleTouchEnd);

}


